import { ReactElement } from 'react';
import classnames from 'classnames';
import { Link } from 'react-router';
import { Icon } from 'components/common';
import { noop } from 'libs';

interface MobileNavItemProps {
  hasNotification?: boolean;
  icon: ReactElement;
  isActive?: boolean;
  isExternalRoute?: boolean;
  isForm?: boolean;
  label: string;
  onClick?: () => void;
  shouldOpenNewWindow?: boolean;
  testId?: string;
  to: string;
}

const MobileNavItem = ({
  hasNotification = false,
  icon,
  isActive = false,
  isExternalRoute = false,
  isForm = false,
  label,
  onClick = noop,
  shouldOpenNewWindow = false,
  testId,
  to,
}: MobileNavItemProps) => {
  const className = classnames('mobile-nav__navlink', {
    active: isActive,
  });

  return (
    <div className="mobile-nav__navlink-container">
      {isForm ? (
        <form action={to} className="mobile-nav__navlink-form" method="POST">
          <input name="_token" type="hidden" value={window.CSRF_TOKEN} />
          <button className={className} data-testid={testId} onClick={onClick} type="submit">
            <MobileNavItemContent hasNotification={hasNotification} icon={icon} label={label} testId={testId} />
          </button>
        </form>
      ) : isExternalRoute ? (
        <a
          className={className}
          data-testid={testId}
          href={to}
          onClick={onClick}
          rel={shouldOpenNewWindow ? 'noopener noreferrer' : undefined}
          target={shouldOpenNewWindow ? '_blank' : undefined}
        >
          <MobileNavItemContent hasNotification={hasNotification} icon={icon} label={label} testId={testId} />
          <Icon className="ps-1 text-0_75" name="arrow-up-right-from-square" />
        </a>
      ) : (
        <Link className={className} data-testid={testId} to={to} onClick={onClick}>
          <MobileNavItemContent hasNotification={hasNotification} icon={icon} label={label} testId={testId} />
        </Link>
      )}
    </div>
  );
};

export default MobileNavItem;

interface MobileNavItemContentProps {
  hasNotification?: boolean;
  icon: ReactElement;
  label: string;
  testId?: string;
}

const MobileNavItemContent = ({ hasNotification = false, icon, label, testId }: MobileNavItemContentProps) => (
  <>
    <span className="mobile-nav__navlink-icon w-6 leading-none">
      {icon}
      {hasNotification && (
        <span
          aria-hidden="true"
          className="mobile-nav__notification-dot"
          data-testid={testId ? `${testId}-notification` : undefined}
        />
      )}
    </span>
    <div className="mobile-nav__label">{label}</div>
  </>
);
